import { defineComponent } from 'vue'
import './style.sass'

export default defineComponent({
  setup () {
    return () => (
      <div class="beta-version-block">
        <p>
          Уважаемые клиенты! <span>Личный кабинет</span> работает в <span>beta-режиме</span>.<br />
          Ваши пожелания и <span>предложения</span> можно направить на электронную почту <a href="mailto:feedback@cable.ru">feedback@cable.ru</a>. Благодарим за обратную связь!
        </p>
      </div>
    )
  }
})